<script>
import menuBar from "@/contents/dashboard/menu-bar.vue";
import { Icon } from '@iconify/vue';

export default {
  components: {
    menuBar,
    Icon,
  },

  data() {
    return {
      mobileDrawer: false,
    };
  },
  computed: {
    isSmallScreen() {
      return this.$vuetify.display.mdAndDown;
    },
  },
  methods: {
    updateJoint(value) {
      this.$emit("updateJoint", value);
    },
    toggleMobileDrawer() {
      this.mobileDrawer = !this.mobileDrawer;
    },
  },
  name: "SideBar",
};
</script>

<template>
  <!-- Mobile view with burger menu -->
  <div v-if="isSmallScreen">
    <!-- Burger menu button -->
    <v-btn icon @click="toggleMobileDrawer" class="burger-menu-btn" variant="text">
      <Icon icon="stash:burger-classic-duotone" width="24" height="24" />
    </v-btn>

    <!-- Mobile drawer -->
    <v-navigation-drawer v-model="mobileDrawer" temporary location="left" :width="295">
      <menuBar ref="menuBarRef" @updateJoint="updateJoint" />
    </v-navigation-drawer>
  </div>

  <!-- Desktop persistent drawer -->
  <v-navigation-drawer v-else :width="295" permanent>
    <menuBar ref="menuBarRef" @updateJoint="updateJoint" />
  </v-navigation-drawer>
</template>

<style>
/* .v-container {
  width: 100%;
  padding: 0px;
  margin-right: auto;
  margin-left: auto;
} */

.v-navigation-drawer__content {
  flex: 0 1 auto;
  height: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 8px;
}

.burger-menu-btn {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.burger-menu-btn:hover {
  background-color: rgba(220, 64, 77, 0.1);
}
</style>
